import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { shopPoliciesQueryOptions } from "@modules/shopify/hooks";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";
import { InfoPolicyBody } from "@modules/shop/components/InfoPage/InfoPolicyBody";

export const Route = createFileRoute(
  "/$locale/_layout/(public)/_public/info/return-policy",
)({
  component: ReturnPolicyPage,
  ssr: true,
  loader: async ({ context: { queryClient }, params }) => {
    const localeVars = getCountryVariables(params.locale);
    return queryClient.ensureQueryData(shopPoliciesQueryOptions(localeVars));
  },
  staleTime: 60_000 * 60, // 1 hour
  headers: () => ({
    "Cache-Control":
      "public, max-age=3600, s-maxage=3600, stale-while-revalidate=86400",
  }),
  head: ({ params, loaderData }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:returnPolicy.title"),
          description: t("Seo:returnPolicy.description"),
        }),
      ],
    };
  },
});

function ReturnPolicyPage() {
  const { locale } = Route.useParams();
  return (
    <InfoPolicyBody
      policyKey="refundPolicy"
      locale={locale}
      titleKey="Footer.information.returns"
    />
  );
}
